import React, { useState } from "react";
import {
  Alert,
  Button,
  Col,
  FloatingLabel,
  Form,
  Row
} from "react-bootstrap";

const TextCaseGenerator = () => {
  const [text, setText] = useState("");
  const [show, setShow] = useState(false);
  const [caseType, setCaseType] = useState("");

  function toTitleCase(str) {
    return str.replace(
      /\w\S*/g,
      (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
  }

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const handleCaseChange = (e) => {
    setCaseType(e.target.value);
  };

  const handleConvert = () => {
    if (caseType === "lower") {
      setText(text.toLowerCase());
    } else if (caseType === "upper") {
      setText(text.toUpperCase());
    } else if (caseType === "sentence") {
      setText(toTitleCase(text));
    }
  };

  function copyText() {
    setShow(true);
    console.log("copy button clicked");
  }

  return (
    <div>
      {show ? (
        <Alert variant="dark" onClose={() => setShow(false)} dismissible>
          Text Copied
        </Alert>
      ) : (
        ""
      )}

      <Row>
        <Col md="6" className="h-100 mb-3 gap-3">
          <FloatingLabel controlId="floatingTextarea2" label="Enter Text">
            <Form.Control
              as="textarea"
              value={text}
              onChange={handleChange}
              placeholder="Enter Text Here"
              style={{ height: "100%" }}
            />
          </FloatingLabel>
          <FloatingLabel className="mt-3" controlId="floatingSelect" label="Select Case">
            <Form.Select aria-label="Floating label select example" onChange={handleCaseChange}>
              <option value="lower" selected>Lower Case</option>
              <option value="upper">Upper Case</option>
              <option value="sentence">Sentence Case</option>
            </Form.Select>
          </FloatingLabel>
          <Button
            variant="dark"
            className="mt-3"
            onClick={handleConvert}
          >
            Convert
          </Button>
        </Col>
        <Col className="order-md-last order-first mb-3">
          <FloatingLabel controlId="floatingTextarea2" label="Output">
            <Form.Control
              as="textarea"
              value={text}
              onChange={handleChange}
              placeholder="output"
              style={{ height: "100%" }}
              readOnly
            />
          </FloatingLabel>
          <Button variant="dark" className="mt-3" onClick={copyText}>
            Copy
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default TextCaseGenerator;
